import React, { useEffect, useState, useRef } from 'react'
import { Bar, Pie } from 'react-chartjs-2'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js'
import ItemList from './ItemList.jsx'
import DashboardVendas from './cards.jsx'
import AnunciosDashboard from './semsku.jsx'
import { FaTrophy } from 'react-icons/fa'
import GreetingCard from './greetingCard.jsx'
import ScheduleCard from './schedule_card.jsx'
import DashboardMonthly from './dashReclaim.jsx'
import CatalogNotification from './catalago.jsx'
import {
  Filter, Hash, Trophy, AlertTriangle, Crown, Medal, Star,
  TrendingUp, TrendingDown, DollarSign, Store, Sparkles, Award,
  Target, ShoppingCart, ShoppingBag, Package, BarChart3, Calendar,
  AlertCircle, Zap, ArrowRight, Truck, Loader2, MapPin, ChevronUp,
  ChevronDown, Edit, PenTool, CreditCard, Plus, QrCode, RefreshCw,
  Copy, CheckCircle, Scissors, Undo, Trash2, Share, User, FileText, Bike
} from 'lucide-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { getMessaging, getToken } from 'firebase/messaging'
import {
  Tooltip as BootstrapTooltip, Button, Card, Col, Container,
  Modal, OverlayTrigger, Row, Table, Toast,
} from 'react-bootstrap'
import Lottie from 'lottie-react'
import Dropdown from 'react-bootstrap/Dropdown'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa'
import animacaoLottie from './animacao.json'
import { format, isBefore, startOfDay } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import {
  faBox, faDollarSign, faGear, faMoneyBills, faMoneyBillTrendUp,
  faMoneyBillWave, faShoppingCart, faTimesCircle, faTruckFast,
} from '@fortawesome/free-solid-svg-icons'
import { Line } from 'react-chartjs-2'
import './dashboard.css'
import { faBolt } from '@fortawesome/free-solid-svg-icons'
import ptBR from 'date-fns/locale/pt-BR'
import { DateTime } from 'luxon'
import { Info, WarningCircle } from 'phosphor-react'
import { AwardFill, BoxArrowUpRight } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { Center } from '../../components/Center/index.jsx'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import PedidosService from '../../services/database/PedidosService/index.js'
import { formatDate } from '../../utils/formatDate.js'
import { formatPrice } from '../../utils/formatPrice.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import {
  AccountDate, AccountTitle, AccountTotal, Code, CodeContent,
  Codes, DateSection,
} from './styles.js'

ChartJS.register(ArcElement, Tooltip, Legend)

/* DESIGN TOKENS – Light / Clean */
const T = {
  bg: '#f4f6f9',
  surface: '#ffffff',
  surfaceHi: '#f8fafc',
  border: '#e2e8f0',
  accent: '#3b82f6',
  accentAlt: '#f59e0b',
  success: '#10b981',
  danger: '#ef4444',
  muted: '#94a3b8',
  text: '#1e293b',
  textSub: '#64748b',
  font: "'DM Sans', 'Segoe UI', sans-serif",
  fontMono: "'JetBrains Mono', monospace",
  radius: '14px',
  radiusSm: '9px',
  shadow: '0 2px 12px rgba(0,0,0,0.07)',
  shadowMd: '0 8px 24px rgba(0,0,0,0.10)',
}

/* Global style injection */
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;600&display=swap');
    .dashboard-root { font-family: 'DM Sans', 'Segoe UI', sans-serif; }
    @keyframes fadeUp { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes spin   { to { transform: rotate(360deg); } }
    @keyframes shimmer { 0% { background-position: -600px 0; } 100% { background-position: 600px 0; } }
    @keyframes barGrow { from { width: 0; } }
    .fade-up   { animation: fadeUp .45s cubic-bezier(.22,1,.36,1) both; }
    .fade-in   { animation: fadeIn .3s ease both; }
    .spin-anim { animation: spin 1s linear infinite; }
  `}</style>
)

/* ── Shared UI atoms ── */
const Chip = ({ children, color = T.accent, style = {} }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', gap: 4,
    padding: '3px 10px', borderRadius: 99,
    background: `${color}18`, border: `1px solid ${color}40`,
    color, fontSize: '0.72rem', fontWeight: 600,
    letterSpacing: '0.04em', ...style,
  }}>{children}</span>
)

const MetricCard = ({ icon: Icon, label, value, sub, color = T.accent, delay = 0, onClick, style = {} }) => (
  <div
    className="fade-up"
    onClick={onClick}
    style={{
      background: T.surface,
      border: `1px solid ${T.border}`,
      borderRadius: T.radius,
      padding: '22px 24px',
      cursor: onClick ? 'pointer' : 'default',
      animationDelay: `${delay}ms`,
      transition: 'transform .2s, box-shadow .2s, border-color .2s',
      position: 'relative', overflow: 'hidden',
      ...style,
    }}
    onMouseEnter={e => {
      e.currentTarget.style.transform = 'translateY(-3px)'
      e.currentTarget.style.boxShadow = `0 8px 32px rgba(0,0,0,0.4), 0 0 0 1px ${color}30`
      e.currentTarget.style.borderColor = `${color}40`
    }}
    onMouseLeave={e => {
      e.currentTarget.style.transform = 'translateY(0)'
      e.currentTarget.style.boxShadow = 'none'
      e.currentTarget.style.borderColor = T.border
    }}
  >
    {/* accent bar */}
    <div style={{ position: 'absolute', top: 0, left: 0, width: 3, height: '100%', background: color, borderRadius: '99px 0 0 99px' }} />

    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
      <div style={{
        width: 40, height: 40, borderRadius: 10,
        background: `${color}18`, display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <Icon size={18} color={color} />
      </div>
      {sub && <Chip color={color}>{sub}</Chip>}
    </div>

    <div style={{ fontSize: '0.78rem', color: T.textSub, marginBottom: 6, fontWeight: 500 }}>{label}</div>
    <div style={{ fontSize: '1.55rem', fontWeight: 700, color: T.text, letterSpacing: '-0.02em' }}>{value}</div>
  </div>
)

const SectionHeader = ({ title, subtitle, icon: Icon, action }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {Icon && (
        <div style={{
          width: 36, height: 36, borderRadius: 10,
          background: `${T.accent}18`, display: 'flex',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon size={16} color={T.accent} />
        </div>
      )}
      <div>
        <div style={{ fontSize: '1.05rem', fontWeight: 700, color: T.text }}>{title}</div>
        {subtitle && <div style={{ fontSize: '0.78rem', color: T.textSub, marginTop: 2 }}>{subtitle}</div>}
      </div>
    </div>
    {action}
  </div>
)

const Divider = () => (
  <div style={{ height: 1, background: T.border, margin: '28px 0' }} />
)

const LoadingRow = () => (
  <div style={{
    height: 48, borderRadius: 8,
    background: 'linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%)',
    backgroundSize: '800px 100%',
    animation: 'shimmer 1.5s infinite',
    marginBottom: 8,
  }} />
)

const EmptyState = ({ icon: Icon = Package, message = 'Nenhum dado disponível.' }) => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', padding: '48px 0', gap: 12,
  }}>
    <div style={{
      width: 56, height: 56, borderRadius: 16,
      background: T.surfaceHi, display: 'flex',
      alignItems: 'center', justifyContent: 'center',
    }}>
      <Icon size={24} color={T.muted} />
    </div>
    <div style={{ color: T.textSub, fontSize: '0.875rem' }}>{message}</div>
  </div>
)

/* ─────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────── */
function Main() {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [dadosDashboard, setDadosDashboard] = useState(null)
  const [dadosVendas, setDadosVendas] = useState([])
  const [dadosVendasFull, setDadosVendasFull] = useState([])
  const [dadosVendasComparativo, setDadosVendasComparativo] = useState({ ontem: {}, hoje: {} })
  const [statistics, setStatistics] = useState([])
  const [dadosMetricas, setMetricas] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingAno, setIsLoadingAno] = useState(false)
  const [dados, setDados] = useState([])
  const [showToast, setShowToast] = useState(false)
  const [totalPerguntas, setTotalPerguntas] = useState(0)
  const [totalDiario, setTotalDiario] = useState([])
  const [anuncios, setAnuncios] = useState([])
  const [greeting, setGreeting] = useState('')
  const [dailySales, setDailySales] = useState([])
  const [isDailySalesLoading, setISDailySalesLoading] = useState(false)
  const [isModalDailySalesOpen, setIsModalDailySalesOpen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const handleShow = () => setShowModal(true)
  const handleClose = () => setShowModal(false)
  const [contas, setContas] = useState([])
  const [isCodesLoading, setIsCodesLoading] = useState(true)
  const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear())
  const anosDisponiveis = [2025, 2024, 2023, 2022, 2021, 2020]
  const navigate = useNavigate()

  const formatarValorReal = (valor) =>
    valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? 'R$ 0,00'

  const total = contas?.reduce((acc, c) => acc + (c?.total || 0), 0)

  async function loadContas() {
    try {
      setIsCodesLoading(true)
      const response = await apinode.get(`/mercado-livre/auth-codes/${localStorage.idconta}`)
      setContas(response.data)
    } catch (err) {
      sendErrorApiMessage('Erro', 'Não foi possível buscar os códigos', err)
    } finally {
      setIsCodesLoading(false)
    }
  }

  const determineGreeting = () => {
    const h = new Date().getHours()
    if (h < 12) return 'Bom dia'
    if (h < 18) return 'Boa tarde'
    return 'Boa noite'
  }

  async function getDailySales() {
    try {
      setISDailySalesLoading(true)
      const data = await PedidosService.getDailySales(new Date())
      setDailySales(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as vendas do dia!')
    } finally {
      setISDailySalesLoading(false)
    }
  }

  async function getStatistics() {
    try {
      const response = await apinode.get(`/accounts-statistics/${localStorage.idconta}`)
      setStatistics(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as contas!')
    }
  }

  async function getAnuncios() {
    try {
      const response = await apinode.get(`/anuncios/count/${localStorage.idconta}`)
      setAnuncios(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar os anúncios!')
    }
  }

  useEffect(() => {
    loadContas()
    setGreeting(determineGreeting())
    getAnuncios()
    getStatistics()

    const localTimeZone = 'America/Sao_Paulo'
    const now = new Date()
    const localDate = utcToZonedTime(now, localTimeZone)
    const dataHoraLocal = DateTime.local()

    consumirMetricas()
    ConsumirComparativo()
    CosumirPorloja(dataHoraLocal)
    ConsumirFull(dataHoraLocal)
    VendasporAno(anoSelecionado)
    fetchData(dataHoraLocal)
  }, [])

  const handleDateChange = (date) => {
    setIsLoading(true)
    fetchData(date)
    CosumirPorloja(date)
    ConsumirFull(date)
    setSelectedDate(date)
  }

  const handleDropdownChange = (ano) => {
    setAnoSelecionado(ano)
    VendasporAno(ano)
  }

  function ConsumirComparativo() {
    apinode.get(`/informacoes-vendas/${localStorage.idconta}`)
      .then(r => setDadosVendasComparativo(r.data))
      .catch(e => console.error(e))
  }

  function consumirMetricas() {
    apinode.get(`/buscar-dados/${localStorage.idconta}`)
      .then(r => { if (r.status === 200) setMetricas(r.data) })
      .catch(e => console.error(e))
  }

  const fetchData = async (date) => {
    try {
      const dataFormatada = format(new Date(date), 'yyyy-MM-dd')
      const response = await apinode.get('/inventario/dashboard', {
        params: { conta: localStorage.idconta, data: dataFormatada },
      })
      setDadosDashboard(response.data)
      setTotalDiario(response.data.totalDiario)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const CosumirPorloja = async (data) => {
    try {
      const response = await apinode.get(`/auth/vendasporloja/${localStorage.idconta}`, { params: { data } })
      setDadosVendas(response.data)
    } catch (e) { console.error(e) }
  }

  const ConsumirFull = async (data) => {
    try {
      const response = await apinode.get(`/auth/vendasporlojafull/${localStorage.idconta}`, { params: { data } })
      setDadosVendasFull(response.data)
    } catch (e) { console.error(e) }
  }

  const VendasporAno = async (ano) => {
    try {
      setIsLoadingAno(true)
      const response = await apinode.get(`/vendasporano/${ano}/${localStorage.idconta}`)
      setDados(response.data)
    } catch (e) { console.error(e) }
    finally { setIsLoadingAno(false) }
  }

  /* ── Sub-components ── */

  const GreetingBanner = () => (
    <div className="fade-up" style={{
      background: T.surface,
      border: `1px solid ${T.border}`,
      borderRadius: T.radius,
      padding: '20px 28px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 24,
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* bg glow */}
      <div style={{
        position: 'absolute', right: -60, top: -60,
        width: 200, height: 200,
        background: `radial-gradient(circle, ${T.accent}10 0%, transparent 70%)`,
        pointerEvents: 'none',
      }} />
      <div>
        <div style={{ fontSize: '0.78rem', color: T.textSub, marginBottom: 4 }}>
          {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
        </div>
        <div style={{ fontSize: '1.4rem', fontWeight: 700, color: T.text }}>
          {greeting}, <span style={{ color: T.accent }}>{localStorage.username}</span>! 👋
        </div>
      </div>
      <Chip color={T.success} style={{ padding: '6px 14px', fontSize: '0.8rem' }}>
        <div style={{ width: 7, height: 7, borderRadius: '50%', background: T.success, marginRight: 4 }} />
        Sistema Online
      </Chip>
    </div>
  )

  const CodigosAutorizacao = () => (
    <div style={{
      background: T.surface,
      border: `1px solid ${T.border}`,
      borderRadius: T.radius,
      padding: 24,
      marginBottom: 24,
    }}>
      <SectionHeader title="Códigos de Autorização" icon={QrCode} />

      {isCodesLoading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[1, 2, 3].map(i => <LoadingRow key={i} />)}
        </div>
      ) : contas.length === 0 ? (
        <EmptyState icon={FileText} message="Sem códigos disponíveis." />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {total !== 0 && (
            <div style={{
              padding: '14px 18px',
              background: `${T.accent}10`,
              borderRadius: T.radiusSm,
              border: `1px solid ${T.accent}25`,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <span style={{ fontWeight: 600, color: T.text }}>Geral</span>
              <Chip color={T.accent}>Total: {total}</Chip>
            </div>
          )}

          {contas.map((conta) => {
            const isOutOfDate = conta?.data_adicao &&
              isBefore(startOfDay(conta.data_adicao), startOfDay(new Date()))

            return (
              <div key={conta.id} style={{
                padding: '14px 18px',
                background: T.surfaceHi,
                borderRadius: T.radiusSm,
                border: `1px solid ${isOutOfDate ? T.danger + '30' : T.border}`,
              }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ fontWeight: 600, color: T.text }}>
                    {conta.apelido} {conta.nome && `· ${conta.nome}`}
                  </span>
                  {conta?.total
                    ? <Chip color={T.accent}>Total: {conta.total}</Chip>
                    : <Chip color={T.muted}>Sem total</Chip>}
                </div>

                {conta?.data_adicao && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                    {isOutOfDate
                      ? <WarningCircle size={13} color={T.danger} />
                      : <Info size={13} color={T.textSub} />}
                    <span style={{ fontSize: '0.75rem', color: isOutOfDate ? T.danger : T.textSub }}>
                      {isOutOfDate ? 'Código antigo — necessário atualizar' : `Adicionado em ${formatDate(conta.data_adicao)}`}
                    </span>
                  </div>
                )}

                <div style={{
                  fontFamily: T.fontMono, fontSize: '0.8rem',
                  color: conta?.codigo ? T.accentAlt : T.muted,
                  background: `${T.bg}80`, padding: '6px 10px',
                  borderRadius: 6, border: `1px solid ${T.border}`,
                }}>
                  {conta?.codigo ?? 'Código não disponível'}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )

  const ComparativoVendasCard = ({ informacoesVendas }) => {
    const canvasRef = useRef(null)
    const ontem = informacoesVendas.ontem
    const hoje = informacoesVendas.hoje

    const pedidosMaiorHoje = hoje.quantidadePedidos >= ontem.quantidadePedidos
    const diferenca = hoje.quantidadePedidos - ontem.quantidadePedidos
    const percentualMudanca = ontem.quantidadePedidos > 0
      ? ((diferenca / ontem.quantidadePedidos) * 100).toFixed(1) : 100

    useEffect(() => {
      const canvas = canvasRef.current
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      canvas.width = 380; canvas.height = 180
      let progress = 0
      let rafId

      const drawBar = (x, h, colorTop, colorBot) => {
        if (!isFinite(h) || h < 1) return
        const y0 = canvas.height - 36 - h
        const y1 = canvas.height - 36
        // only create gradient when y0 !== y1 and both finite
        if (!isFinite(y0) || !isFinite(y1) || y0 === y1) {
          ctx.fillStyle = colorTop
        } else {
          const g = ctx.createLinearGradient(0, y0, 0, y1)
          g.addColorStop(0, colorTop)
          g.addColorStop(1, colorBot)
          ctx.fillStyle = g
        }
        ctx.beginPath()
        if (ctx.roundRect) {
          ctx.roundRect(x, y0, 64, h, [6, 6, 0, 0])
        } else {
          ctx.rect(x, y0, 64, h)
        }
        ctx.fill()
      }

      const animate = () => {
        if (progress >= 1) return
        progress = Math.min(progress + 0.025, 1)
        ctx.clearRect(0, 0, canvas.width, canvas.height)

        const maxVal = Math.max(ontem.quantidadePedidos || 0, hoje.quantidadePedidos || 0, 1)
        const maxH = canvas.height - 52

        const hOntem = ((ontem.quantidadePedidos || 0) / maxVal) * maxH * progress
        const hHoje = ((hoje.quantidadePedidos || 0) / maxVal) * maxH * progress

        drawBar(60, hOntem, '#f59e0b', '#f59e0b40')
        drawBar(60 + 110, hHoje, '#3b82f6', '#3b82f640')

        // Labels
        ctx.fillStyle = '#94a3b8'
        ctx.font = '600 12px sans-serif'
        ctx.textAlign = 'center'
        ctx.fillText('Ontem', 60 + 32, canvas.height - 14)
        ctx.fillText('Hoje', 60 + 110 + 32, canvas.height - 14)

        // Values
        ctx.fillStyle = '#1e293b'
        ctx.font = 'bold 14px sans-serif'
        if (hOntem > 20) ctx.fillText(Math.round((ontem.quantidadePedidos || 0) * progress), 60 + 32, canvas.height - 36 - hOntem - 8)
        if (hHoje > 20) ctx.fillText(Math.round((hoje.quantidadePedidos || 0) * progress), 60 + 110 + 32, canvas.height - 36 - hHoje - 8)

        rafId = requestAnimationFrame(animate)
      }
      animate()
      return () => cancelAnimationFrame(rafId)
    }, [ontem.quantidadePedidos, hoje.quantidadePedidos])

    return (
      <div style={{
        background: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: T.radius,
        padding: 24,
      }}>
        <SectionHeader
          title="Comparativo de Pedidos"
          subtitle="Ontem vs Hoje"
          icon={BarChart3}
          action={
            <Chip color={pedidosMaiorHoje ? T.success : T.danger}>
              {pedidosMaiorHoje ? <TrendingUp size={11} /> : <TrendingDown size={11} />}
              {' '}{Math.abs(percentualMudanca)}%
            </Chip>
          }
        />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
          {[
            { label: 'Ontem', value: ontem.quantidadePedidos, color: T.accentAlt },
            { label: 'Hoje', value: hoje.quantidadePedidos, color: T.accent },
          ].map(({ label, value, color }) => (
            <div key={label} style={{
              padding: '14px 16px',
              background: `${color}0f`,
              border: `1px solid ${color}25`,
              borderRadius: T.radiusSm,
            }}>
              <div style={{ fontSize: '0.75rem', color: T.textSub, marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: '1.8rem', fontWeight: 800, color }}>{value ?? 0}</div>
              <div style={{ fontSize: '0.72rem', color: T.muted, marginTop: 2 }}>pedidos</div>
            </div>
          ))}
        </div>

        <div style={{
          background: T.surfaceHi, borderRadius: T.radiusSm,
          padding: '16px', display: 'flex', justifyContent: 'center', border: `1px solid ${T.border}`,
        }}>
          <canvas ref={canvasRef} style={{ maxWidth: '100%', height: 'auto' }} />
        </div>

        <div style={{
          marginTop: 16, padding: '10px 14px',
          background: pedidosMaiorHoje ? `${T.success}10` : `${T.danger}10`,
          border: `1px solid ${pedidosMaiorHoje ? T.success : T.danger}30`,
          borderRadius: T.radiusSm,
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <span style={{ fontSize: '0.8rem', color: T.textSub }}>Diferença</span>
          <span style={{ fontWeight: 700, color: pedidosMaiorHoje ? T.success : T.danger }}>
            {diferenca > 0 ? '+' : ''}{diferenca} pedidos
          </span>
        </div>
      </div>
    )
  }

  const ComparativoValorTotalCard = ({ informacoesVendas }) => {
    if (!informacoesVendas?.ontem || !informacoesVendas?.hoje) return null
    const { ontem, hoje } = informacoesVendas
    if (isNaN(ontem.valorTotal) || isNaN(hoje.valorTotal)) return null

    const maior = hoje.valorTotal > ontem.valorTotal
    const igual = hoje.valorTotal === ontem.valorTotal

    return (
      <div style={{
        background: T.surface,
        border: `1px solid ${T.border}`,
        borderRadius: T.radius,
        padding: 24,
      }}>
        <SectionHeader title="Comparativo de Valor" subtitle="Ontem vs Hoje" icon={DollarSign} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 16 }}>
          {[
            { label: 'Ontem', value: ontem.valorTotal, color: T.accentAlt },
            { label: 'Hoje', value: hoje.valorTotal, color: T.accent },
          ].map(({ label, value, color }) => (
            <div key={label} style={{
              padding: '14px 16px',
              background: `${color}0f`,
              border: `1px solid ${color}25`,
              borderRadius: T.radiusSm,
            }}>
              <div style={{ fontSize: '0.75rem', color: T.textSub, marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: '1.1rem', fontWeight: 700, color }}>
                {value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? 'N/D'}
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {!igual && (maior ? <TrendingUp size={16} color={T.success} /> : <TrendingDown size={16} color={T.danger} />)}
          <span style={{ fontSize: '0.8rem', color: igual ? T.muted : maior ? T.success : T.danger, fontWeight: 600 }}>
            {igual ? 'Valores iguais' : maior ? 'Acima de ontem' : 'Abaixo de ontem'}
          </span>
        </div>

        <div style={{ marginTop: 12 }}>
          <Lottie animationData={animacaoLottie} style={{ height: 40 }} />
        </div>
      </div>
    )
  }

  const GraficoComparativo = () => {
    const meses = dados.map(d => d.MES)
    const data = {
      labels: meses,
      datasets: [
        { label: 'Vendas Bruto', data: dados.map(d => d.TOTAL_VENDAS_BRUTO), backgroundColor: `${T.accent}cc` },
        { label: 'Frete', data: dados.map(d => d.FRETE), backgroundColor: `${T.danger}cc` },
        { label: 'Venda Líquida', data: dados.map(d => d.VENDA_LIQUIDA), backgroundColor: `${T.success}cc` },
      ],
    }
    const options = {
      responsive: true,
      plugins: { legend: { labels: { color: '#1e293b', font: { family: 'DM Sans' } } } },
      scales: {
        x: { ticks: { color: '#64748b' }, grid: { color: '#e2e8f0' } },
        y: { ticks: { color: '#64748b' }, grid: { color: '#e2e8f0' }, beginAtZero: true },
      },
    }
    return (
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: T.radius, padding: 24,
      }}>
        <SectionHeader title="Vendas por Mês" icon={BarChart3} />
        <Bar data={data} options={options} />
      </div>
    )
  }

  const fmt = (v) =>
    (v ?? 0).toLocaleString("pt-BR", { style: "decimal", minimumFractionDigits: 2 })

  const Badge = ({ color, bg, children }) => (
    <span style={{
      display: "inline-flex", alignItems: "center",
      padding: "2px 8px", borderRadius: 6,
      background: bg, color, fontSize: "0.68rem",
      fontWeight: 700, letterSpacing: "0.03em",
    }}>{children}</span>
  )

  const MiniBar = ({ value, max, color }) => {
    const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0
    return (
      <div style={{
        width: 56, height: 3, borderRadius: 2,
        background: "#e8eaf0", overflow: "hidden", marginTop: 4,
      }}>
        <div style={{
          width: `${pct}%`, height: "100%",
          background: color, borderRadius: 2,
          transition: "width 0.5s ease",
        }} />
      </div>
    )
  }


  const TabelaComparativa = ({ dados = [] }) => {
    const [hover, setHover] = useState(null)

    const maxBruto = Math.max(...dados.map(m => m.faturamento_bruto ?? 0))
    const maxPedidos = Math.max(...dados.map(m => m.total_pedidos ?? 0))

    const getFreteTotal = (m) => (m.valor_frete ?? 0) + (m.frete_paid_range ?? 0)
    const getLiquido = (m) => (m.faturamento_bruto ?? 0) - getFreteTotal(m)

    const cols = [
      "Mês", "Pedidos", "Bruto",
      "Frete >79",
      "Frete 19–79",
      "Líquido", "Parts", "Cancel.", "Vlr Cancel.",
      "% Cancel.", "Fulfillm.", "% Fulfillm.", "Δ Mês", "Var %",
    ]

    return (
      <div style={{
        background: "#f5f6fa",
        padding: "36px 28px",
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
      }}>

        {/* Header */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 4 }}>
            <div style={{
              width: 4, height: 28, borderRadius: 2,
              background: "linear-gradient(180deg, #6366f1, #8b5cf6)",
            }} />
            <h2 style={{
              margin: 0, fontSize: "1.25rem", fontWeight: 800,
              color: "#1e1e2e", letterSpacing: "-0.02em",
            }}>
              Desempenho Mensal
              <span style={{
                marginLeft: 10, fontSize: "0.7rem", fontWeight: 500,
                color: "#9091a0", letterSpacing: "0.08em",
                textTransform: "uppercase",
              }}>
                {dados[0]?.ano ?? ""}
              </span>
            </h2>
          </div>
          <p style={{ margin: 0, color: "#9091a0", fontSize: "0.78rem", paddingLeft: 16 }}>
            Comparativo mês a mês · faturamento, frete ajustado, cancelamentos e fulfillment
          </p>
        </div>

        {/* Card */}
        <div style={{
          background: "#fff",
          borderRadius: 16,
          border: "1px solid #e4e5f0",
          boxShadow: "0 2px 16px rgba(99,102,241,0.06)",
          overflow: "hidden",
        }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.76rem" }}>

              <thead>
                <tr style={{ background: "#fafafc", borderBottom: "2px solid #e4e5f0" }}>
                  {cols.map((h, i) => (
                    <th key={i} style={{
                      padding: "12px 14px",
                      textAlign: i === 0 ? "left" : "right",
                      color: h === "Frete >79"
                        ? "#d97706"
                        : h === "Frete 19–79"
                          ? "#6366f1"
                          : "#9091a0",
                      fontWeight: 700,
                      fontSize: "0.63rem", letterSpacing: "0.1em",
                      textTransform: "uppercase", whiteSpace: "nowrap",
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {dados.map((mes, index) => {
                  const anterior = index > 0 ? dados[index - 1] : null
                  const liquido = getLiquido(mes)
                  const liquidoAnt = anterior ? getLiquido(anterior) : 0
                  const dif = anterior ? liquido - liquidoAnt : 0
                  const pct = anterior && liquidoAnt
                    ? ((dif / liquidoAnt) * 100).toFixed(1) : null
                  const isPos = dif >= 0
                  const isHov = hover === index
                  const cancelPct = Number(mes.percentual_cancelado ?? 0)
                  const fulfillPct = Number(mes.percentual_fullfilment ?? 0)

                  return (
                    <tr
                      key={index}
                      onMouseEnter={() => setHover(index)}
                      onMouseLeave={() => setHover(null)}
                      style={{
                        borderBottom: "1px solid #f0f1f8",
                        background: isHov
                          ? "linear-gradient(90deg, #f5f3ff 0%, #fafafc 100%)"
                          : index % 2 === 0 ? "#fff" : "#fdfcff",
                        transition: "background 0.15s",
                      }}
                    >
                      {/* Mês */}
                      <td style={{ padding: "13px 14px", whiteSpace: "nowrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div style={{
                            width: 28, height: 28, borderRadius: 8,
                            background: isHov
                              ? "linear-gradient(135deg, #6366f1, #8b5cf6)"
                              : "#ededf8",
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: "0.6rem", fontWeight: 800,
                            color: isHov ? "#fff" : "#6366f1",
                            transition: "all 0.2s", flexShrink: 0,
                          }}>
                            {String(mes.mes_num ?? index + 1).padStart(2, "0")}
                          </div>
                          <span style={{ color: "#1e1e2e", fontWeight: 600, fontSize: "0.8rem" }}>
                            {mes.mes?.trim()}
                          </span>
                        </div>
                      </td>

                      {/* Pedidos */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                          <span style={{ color: "#1e1e2e", fontWeight: 600 }}>
                            {(mes.total_pedidos ?? 0).toLocaleString("pt-BR")}
                          </span>
                          <MiniBar value={mes.total_pedidos ?? 0} max={maxPedidos} color="#6366f1" />
                        </div>
                      </td>

                      {/* Bruto */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                          <span style={{ color: "#5a5b70" }}>{fmt(mes.faturamento_bruto)}</span>
                          <MiniBar value={mes.faturamento_bruto ?? 0} max={maxBruto} color="#c7d2fe" />
                        </div>
                      </td>

                      {/* Frete >79 */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <span style={{ color: "#d97706", fontWeight: 600 }}>
                          {fmt(mes.valor_frete ?? 0)}
                        </span>
                      </td>

                      {/* Frete 19–79 */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <span style={{ color: "#6366f1", fontWeight: 600 }}>
                          {fmt(mes.frete_paid_range ?? 0)}
                        </span>
                      </td>

                      {/* Líquido */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <span style={{ color: "#059669", fontWeight: 800, fontSize: "0.82rem" }}>
                          {fmt(liquido)}
                        </span>
                      </td>

                      {/* Parts */}
                      <td style={{ padding: "13px 14px", textAlign: "right", color: "#9091a0" }}>
                        {fmt(mes.valor_parts)}
                      </td>

                      {/* Cancel qtd */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {(mes.total_cancelado ?? 0) > 0
                          ? <Badge color="#dc2626" bg="#fee2e2">{mes.total_cancelado}</Badge>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>

                      {/* Vlr cancelado */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        <span style={{ color: (mes.valor_cancelado ?? 0) > 0 ? "#dc2626" : "#d0d1e0" }}>
                          {(mes.valor_cancelado ?? 0) > 0 ? fmt(mes.valor_cancelado) : "—"}
                        </span>
                      </td>

                      {/* % Cancel */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {cancelPct > 0
                          ? <Badge
                            color={cancelPct >= 10 ? "#dc2626" : cancelPct >= 5 ? "#d97706" : "#059669"}
                            bg={cancelPct >= 10 ? "#fee2e2" : cancelPct >= 5 ? "#fef3c7" : "#d1fae5"}
                          >
                            {cancelPct.toFixed(1)}%
                          </Badge>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>

                      {/* Fulfillment qtd */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {(mes.total_fullfilment ?? 0) > 0
                          ? <Badge color="#0369a1" bg="#e0f2fe">{mes.total_fullfilment}</Badge>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>

                      {/* % Fulfillment */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {fulfillPct > 0
                          ? <Badge color="#0369a1" bg="#e0f2fe">{fulfillPct.toFixed(1)}%</Badge>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>

                      {/* Δ Líquido */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {anterior
                          ? <span style={{ color: isPos ? "#059669" : "#dc2626", fontWeight: 600 }}>
                            {isPos ? "+" : ""}{fmt(dif)}
                          </span>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>

                      {/* Var % */}
                      <td style={{ padding: "13px 14px", textAlign: "right" }}>
                        {pct !== null
                          ? <Badge
                            color={isPos ? "#059669" : "#dc2626"}
                            bg={isPos ? "#d1fae5" : "#fee2e2"}
                          >
                            {isPos ? "▲" : "▼"} {Math.abs(pct)}%
                          </Badge>
                          : <span style={{ color: "#d0d1e0" }}>—</span>
                        }
                      </td>
                    </tr>
                  )
                })}
              </tbody>

              {/* Totais */}
              {dados.length > 0 && (() => {
                const totalPedidos = dados.reduce((a, m) => a + (m.total_pedidos ?? 0), 0)
                const totalBruto = dados.reduce((a, m) => a + (m.faturamento_bruto ?? 0), 0)
                const totalFrete79 = dados.reduce((a, m) => a + (m.valor_frete ?? 0), 0)
                const totalFrete1979 = dados.reduce((a, m) => a + (m.frete_paid_range ?? 0), 0)
                const totalLiquido = dados.reduce((a, m) => a + getLiquido(m), 0)
                const totalParts = dados.reduce((a, m) => a + (m.valor_parts ?? 0), 0)
                const totalCancel = dados.reduce((a, m) => a + (m.total_cancelado ?? 0), 0)
                const totalVlrCancel = dados.reduce((a, m) => a + (m.valor_cancelado ?? 0), 0)
                const totalFulfill = dados.reduce((a, m) => a + (m.total_fullfilment ?? 0), 0)
                const pctCancel = totalPedidos > 0 ? ((totalCancel / totalPedidos) * 100).toFixed(1) : 0
                const pctFulfill = totalPedidos > 0 ? ((totalFulfill / totalPedidos) * 100).toFixed(1) : 0

                return (
                  <tr style={{
                    background: "linear-gradient(90deg, #f5f3ff, #fafafc)",
                    borderTop: "2px solid #e4e5f0",
                  }}>
                    <td style={{ padding: "14px 14px" }}>
                      <span style={{
                        fontSize: "0.62rem", fontWeight: 800,
                        color: "#6366f1", letterSpacing: "0.12em",
                        textTransform: "uppercase",
                      }}>Total Geral</span>
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#1e1e2e", fontWeight: 700 }}>
                      {totalPedidos.toLocaleString("pt-BR")}
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#5a5b70", fontWeight: 700 }}>
                      {fmt(totalBruto)}
                    </td>
                    {/* Frete >79 total */}
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#d97706", fontWeight: 700 }}>
                      {fmt(totalFrete79)}
                    </td>
                    {/* Frete 19–79 total */}
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#6366f1", fontWeight: 700 }}>
                      {fmt(totalFrete1979)}
                    </td>
                    {/* Líquido total */}
                    <td style={{ padding: "14px 14px", textAlign: "right" }}>
                      <span style={{ color: "#059669", fontWeight: 800, fontSize: "0.85rem" }}>
                        {fmt(totalLiquido)}
                      </span>
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#9091a0" }}>
                      {fmt(totalParts)}
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right" }}>
                      <Badge color="#dc2626" bg="#fee2e2">{totalCancel}</Badge>
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right", color: "#dc2626", fontWeight: 700 }}>
                      {fmt(totalVlrCancel)}
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right" }}>
                      <Badge color="#dc2626" bg="#fee2e2">{pctCancel}%</Badge>
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right" }}>
                      <Badge color="#0369a1" bg="#e0f2fe">{totalFulfill}</Badge>
                    </td>
                    <td style={{ padding: "14px 14px", textAlign: "right" }}>
                      <Badge color="#0369a1" bg="#e0f2fe">{pctFulfill}%</Badge>
                    </td>
                    <td colSpan={2} />
                  </tr>
                )
              })()}
            </table>
          </div>
        </div>
      </div>
    )
  }



  const TabelaVendas = ({ totalDiario: dados = totalDiario }) => {
    const calcTotal = (col) => dados.reduce((s, i) => s + (i[col] || 0), 0)
    const totalVendas = calcTotal('TOTALVENDASDIA')
    const totalCanceladas = calcTotal('TOTALVENDASCANCELADAS')
    const taxaCanc = totalVendas ? ((totalCanceladas / totalVendas) * 100).toFixed(2) : '0.00'

    return (
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: T.radius, padding: 24, marginBottom: 24,
      }}>
        <SectionHeader title="Total Diário de Vendas" icon={Calendar} />

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 24 }}>
          {[
            { label: 'Total Vendas', value: formatarValorReal(totalVendas), color: T.success, icon: TrendingUp },
            { label: 'Total Canceladas', value: formatarValorReal(totalCanceladas), color: T.danger, icon: TrendingDown },
            { label: 'Taxa Cancelamento', value: `${taxaCanc}%`, color: T.accentAlt, icon: AlertCircle },
          ].map(({ label, value, color, icon: Icon }) => (
            <div key={label} style={{
              padding: '16px 18px', borderRadius: T.radiusSm,
              background: `${color}0a`, border: `1px solid ${color}20`,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                <span style={{ fontSize: '0.75rem', color: T.textSub }}>{label}</span>
                <Icon size={14} color={color} />
              </div>
              <div style={{ fontSize: '1.15rem', fontWeight: 700, color }}>{value}</div>
            </div>
          ))}
        </div>

        {dados && dados.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  {['Dia', 'Total Vendas', 'Canceladas'].map(h => (
                    <th key={h} style={{
                      padding: '10px 14px', textAlign: 'left',
                      fontSize: '0.72rem', color: T.textSub,
                      textTransform: 'uppercase', letterSpacing: '0.07em',
                      borderBottom: `1px solid ${T.border}`,
                      background: T.surfaceHi,
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dados.map((item, i) => {
                  let dataFmt = item.DIA
                  try {
                    const parts = item.DIA.includes('/') ? item.DIA.split('/') : null
                    const d = parts
                      ? new Date(parts[2], parts[1] - 1, parts[0])
                      : new Date(item.DIA + 'T00:00:00')
                    if (!isNaN(d)) dataFmt = d.toLocaleDateString('pt-BR')
                  } catch { }

                  const maxVen = Math.max(...dados.map(d => d.TOTALVENDASDIA), 1)
                  const maxCan = Math.max(...dados.map(d => d.TOTALVENDASCANCELADAS), 1)

                  return (
                    <tr key={i} style={{ borderBottom: `1px solid ${T.border}` }}
                      onMouseEnter={e => e.currentTarget.style.background = `${T.accent}08`}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <td style={{ padding: '10px 14px', color: T.text }}>{dataFmt}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <span style={{ color: T.success, fontWeight: 600 }}>{formatarValorReal(item.TOTALVENDASDIA)}</span>
                          <div style={{ flex: 1, height: 4, background: T.surfaceHi, borderRadius: 2, overflow: 'hidden', minWidth: 60 }}>
                            <div style={{ height: '100%', background: T.success, borderRadius: 2, width: `${(item.TOTALVENDASDIA / maxVen) * 100}%`, animation: 'barGrow .8s ease' }} />
                          </div>
                        </div>
                      </td>
                      <td style={{ padding: '10px 14px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <span style={{ color: T.danger, fontWeight: 600 }}>{formatarValorReal(item.TOTALVENDASCANCELADAS)}</span>
                          <div style={{ flex: 1, height: 4, background: T.surfaceHi, borderRadius: 2, overflow: 'hidden', minWidth: 60 }}>
                            <div style={{ height: '100%', background: T.danger, borderRadius: 2, width: `${(item.TOTALVENDASCANCELADAS / maxCan) * 100}%`, animation: 'barGrow .8s ease' }} />
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                })}
                <tr style={{ background: T.surfaceHi }}>
                  <td style={{ padding: '12px 14px', fontWeight: 700, color: T.text, fontSize: '0.85rem' }}>TOTAIS</td>
                  <td style={{ padding: '12px 14px' }}><Chip color={T.success}>{formatarValorReal(totalVendas)}</Chip></td>
                  <td style={{ padding: '12px 14px' }}><Chip color={T.danger}>{formatarValorReal(totalCanceladas)}</Chip></td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <EmptyState icon={Calendar} message="Nenhum dado disponível." />
        )}
      </div>
    )
  }

  const AccountStatistics = () => (
    <div style={{
      background: T.surface, border: `1px solid ${T.border}`,
      borderRadius: T.radius, padding: 24, marginBottom: 24,
    }}>
      <SectionHeader title="Estatísticas das Contas" icon={BarChart3} />
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 14 }}>
        {statistics.map((stat, i) => (
          <div key={i} style={{
            width: 300, background: T.surfaceHi,
            borderRadius: T.radiusSm, padding: 20,
            border: `1px solid ${T.border}`,
            transition: 'transform .2s',
          }}
            onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
            onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <span style={{ fontWeight: 700, color: T.text }}>{stat.account}</span>
              <AwardFill size={20} color={stat.level_partner === 'gold' ? '#FFD700' : T.muted} />
            </div>
            {[
              { label: 'Vendas', value: stat.sales },
              { label: 'Reclamações', value: `${stat.percentage_claims} (${stat.total_claims})` },
              { label: 'Atrasos', value: `${stat.percentage_delayed} (${stat.total_delayed})` },
              { label: 'Cancelados', value: `${stat.percentage_canceled} (${stat.total_canceled})` },
            ].map(({ label, value }) => (
              <div key={label} style={{
                display: 'flex', justifyContent: 'space-between',
                padding: '6px 0', borderBottom: `1px solid ${T.border}`,
              }}>
                <span style={{ fontSize: '0.78rem', color: T.textSub }}>{label}</span>
                <span style={{ fontSize: '0.8rem', fontWeight: 600, color: T.text }}>{value}</span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  )

  const SalesRanking = () => {
    const [animVals, setAnimVals] = useState({})
    const vendas = Array.isArray(dadosVendas) ? dadosVendas : []
    const sorted = vendas.slice().sort((a, b) => (b?.NUM_PEDIDOS || 0) - (a?.NUM_PEDIDOS || 0))
    const maxSales = sorted[0]?.NUM_PEDIDOS || 1

    useEffect(() => {
      const timeouts = []
      const t = setTimeout(() => {
        sorted.forEach((entry, i) => {
          const t2 = setTimeout(() => {
            setAnimVals(prev => ({ ...prev, [entry.APELIDO]: entry.NUM_PEDIDOS || 0 }))
          }, i * 120)
          timeouts.push(t2)
        })
      }, 200)
      return () => { clearTimeout(t); timeouts.forEach(clearTimeout) }
    }, [vendas.length])

    const rankColors = ['#f59e0b', '#94a3b8', '#cd7f32']
    const rankLabels = ['1º', '2º', '3º']

    return (
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: T.radius, padding: 24, marginBottom: 24,
      }}>
        <SectionHeader title="Ranking de Vendas" subtitle="Performance diária das lojas" icon={Trophy} />

        {/* Podium */}
        {sorted.length >= 3 && (
          <div style={{
            display: 'grid', gridTemplateColumns: '1fr 1.1fr 1fr',
            gap: 12, maxWidth: 600, margin: '0 auto 28px auto',
            alignItems: 'end',
          }}>
            {[1, 0, 2].map((pos) => {
              const entry = sorted[pos] || {}
              const h = pos === 0 ? 130 : pos === 1 ? 100 : 88
              const color = rankColors[pos]

              return (
                <div key={pos} className="fade-up" style={{
                  background: T.surfaceHi,
                  border: `1px solid ${color}30`,
                  borderRadius: T.radius, padding: '16px 12px',
                  textAlign: 'center', height: h,
                  display: 'flex', flexDirection: 'column',
                  justifyContent: 'space-between',
                  animationDelay: `${pos * 100}ms`,
                }}>
                  <FaTrophy style={{ fontSize: 20, color }} />
                  <div>
                    <div style={{ fontSize: '0.72rem', color: T.textSub, marginBottom: 2 }}>{entry.APELIDO ?? 'N/A'}</div>
                    <div style={{ fontSize: '1.4rem', fontWeight: 800, color }}>{entry.NUM_PEDIDOS ?? 0}</div>
                    <div style={{ fontSize: '0.65rem', color: T.muted }}>{rankLabels[pos]}</div>
                  </div>
                </div>
              )
            })}
          </div>
        )}

        {/* Full list */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {sorted.map((entry, i) => {
            const pct = (entry.NUM_PEDIDOS / maxSales) * 100
            const color = i === 0 ? rankColors[0] : i === 1 ? rankColors[1] : i === 2 ? rankColors[2] : T.accent

            return (
              <div key={entry.APELIDO || i} style={{
                display: 'grid', gridTemplateColumns: '44px 1fr 80px 130px',
                alignItems: 'center', gap: 14,
                padding: '12px 16px', borderRadius: T.radiusSm,
                background: T.surfaceHi, border: `1px solid ${T.border}`,
                transition: 'transform .2s',
              }}
                onMouseEnter={e => e.currentTarget.style.transform = 'translateX(4px)'}
                onMouseLeave={e => e.currentTarget.style.transform = 'translateX(0)'}
              >
                <div style={{
                  width: 36, height: 36, borderRadius: '50%',
                  background: i < 3 ? `${color}20` : T.surface,
                  border: `1px solid ${i < 3 ? color : T.border}`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: i < 3 ? color : T.muted, fontSize: '0.85rem', fontWeight: 700,
                }}>
                  {i < 3 ? <FaTrophy /> : i + 1}
                </div>

                <div>
                  <div style={{ fontWeight: 600, color: T.text, marginBottom: 6, fontSize: '0.9rem' }}>{entry.APELIDO}</div>
                  <div style={{ height: 5, background: T.surface, borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{
                      height: '100%', background: color, borderRadius: 3,
                      width: `${(animVals[entry.APELIDO] || 0) / maxSales * 100}%`,
                      transition: 'width 1.5s cubic-bezier(.4,0,.2,1)',
                    }} />
                  </div>
                </div>

                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: '1.3rem', fontWeight: 800, color }}>{animVals[entry.APELIDO] || 0}</div>
                  <div style={{ fontSize: '0.67rem', color: T.muted }}>pedidos</div>
                </div>

                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: '0.9rem', fontWeight: 700, color: T.success }}>
                    {entry.TOTAL_VALOR?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0 }) ?? 'R$ 0'}
                  </div>
                  <div style={{ fontSize: '0.67rem', color: T.muted }}>faturamento</div>
                </div>
              </div>
            )
          })}
          {sorted.length === 0 && <EmptyState message="Sem dados de vendas." />}
        </div>
      </div>
    )
  }

  const FulfillmentDashboard = () => {
    const totalPedidos = dadosVendasFull.reduce((a, v) => a + v.NUM_PEDIDOS, 0)
    const totalVendas = dadosVendasFull.reduce((a, v) => a + v.TOTAL_VALOR, 0)

    return (
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: T.radius, padding: 24, marginBottom: 24,
      }}>
        <SectionHeader title="Fulfillment por Loja" icon={Package} />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 24 }}>
          <MetricCard icon={ShoppingCart} label="Total de Pedidos" value={totalPedidos.toLocaleString()} color={T.success} />
          <MetricCard icon={DollarSign} label="Total de Vendas" value={formatarValorReal(totalVendas)} color={T.accent} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 }}>
          {dadosVendasFull.map((venda, i) => (
            <div key={i} style={{
              background: T.surfaceHi, borderRadius: T.radiusSm,
              border: `1px solid ${T.border}`, padding: '18px 20px',
              transition: 'transform .2s, box-shadow .2s',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = T.shadow }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <span style={{ fontWeight: 700, color: T.text, fontSize: '0.95rem' }}>{venda.APELIDO}</span>
                <Chip color={T.success}>Ativo</Chip>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: `${T.success}0a`, borderRadius: 8, border: `1px solid ${T.success}15` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <ShoppingCart size={13} color={T.success} />
                    <span style={{ fontSize: '0.78rem', color: T.textSub }}>Pedidos</span>
                  </div>
                  <span style={{ fontWeight: 700, color: T.success }}>{venda.NUM_PEDIDOS}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 10px', background: `${T.accent}0a`, borderRadius: 8, border: `1px solid ${T.accent}15` }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <DollarSign size={13} color={T.accent} />
                    <span style={{ fontSize: '0.78rem', color: T.textSub }}>Vendas</span>
                  </div>
                  <span style={{ fontWeight: 700, color: T.accent }}>
                    {venda.TOTAL_VALOR?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const OrderList = () => {
    const [orders, setOrders] = useState([])
    const [loading, setLoading] = useState(true)
    const [date, setDate] = useState(new Date())
    const [mktFilters, setMktFilters] = useState({})

    const uniqueMkt = [...new Set(orders.map(o => o.APELIDO))]

    useEffect(() => {
      setLoading(true)
      const fmt = date.toISOString().split('T')[0]
      apinode.get(`auth/vendasporitem/${localStorage.idconta}`, { params: { data: fmt } })
        .then(r => { setOrders(r.data); setLoading(false) })
        .catch(() => setLoading(false))
    }, [date])

    const grouped = orders
      .filter(o => {
        const sel = Object.keys(mktFilters).filter(k => mktFilters[k])
        return sel.length === 0 || sel.includes(o.APELIDO)
      })
      .reduce((g, o) => {
        if (!g[o.PEDIDO]) g[o.PEDIDO] = { ...o, FRETE: 0, DESCRICAO: [], QUANTIDADE: [], VALOR_TOTAL_ITEM: [], INTEGRADO: [] }
        g[o.PEDIDO].FRETE += o.VLRFRETE
        g[o.PEDIDO].DESCRICAO.push(o.DESCRICAO)
        g[o.PEDIDO].QUANTIDADE.push(o.QUANTIDADE)
        g[o.PEDIDO].VALOR_TOTAL_ITEM.push(o.VALOR_TOTAL_ITEM)
        g[o.PEDIDO].INTEGRADO.push(o.INTEGRADO)
        return g
      }, {})

    const fmtCur = (v) => v?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) ?? ''

    return (
      <div style={{
        background: T.surface, border: `1px solid ${T.border}`,
        borderRadius: T.radius, padding: 24, marginBottom: 24,
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 14, marginBottom: 20 }}>
          <SectionHeader title="Pedidos do Dia" icon={ShoppingBag} subtitle={date.toLocaleDateString('pt-BR')} />

          <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            {uniqueMkt.length > 0 && (
              <>
                <span style={{ fontSize: '0.75rem', color: T.textSub, display: 'flex', alignItems: 'center', gap: 4 }}>
                  <Filter size={12} /> Filtrar:
                </span>
                {uniqueMkt.map(mk => (
                  <label key={mk} style={{
                    display: 'flex', alignItems: 'center', gap: 5,
                    cursor: 'pointer', padding: '4px 10px', borderRadius: 99,
                    background: mktFilters[mk] ? `${T.accent}15` : T.surfaceHi,
                    border: `1px solid ${mktFilters[mk] ? T.accent : T.border}`,
                    fontSize: '0.78rem', color: mktFilters[mk] ? T.accent : T.textSub,
                    transition: 'all .2s',
                  }}>
                    <input type="checkbox" checked={mktFilters[mk] || false}
                      onChange={() => setMktFilters(p => ({ ...p, [mk]: !p[mk] }))}
                      style={{ margin: 0 }} />
                    {mk}
                  </label>
                ))}
              </>
            )}

            <DatePicker
              selected={date}
              onChange={setDate}
              dateFormat="dd/MM/yyyy"
              locale={ptBR}
              className="form-control"
            />
          </div>
        </div>

        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {[1, 2, 3, 4].map(i => <LoadingRow key={i} />)}
          </div>
        ) : Object.keys(grouped).length === 0 ? (
          <EmptyState icon={ShoppingBag} message="Nenhum pedido encontrado para esta data." />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxHeight: 520, overflowY: 'auto', paddingRight: 4 }}>
            {Object.keys(grouped).map(pedido => (
              <div key={pedido} style={{
                background: T.surfaceHi, borderRadius: T.radiusSm,
                border: `1px solid ${T.border}`, padding: 14,
                transition: 'border-color .2s',
              }}
                onMouseEnter={e => e.currentTarget.style.borderColor = `${T.accent}40`}
                onMouseLeave={e => e.currentTarget.style.borderColor = T.border}
              >
                {/* Pedido header */}
                <div style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  marginBottom: 10, paddingBottom: 10, borderBottom: `1px solid ${T.border}`,
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                      background: T.accent, borderRadius: 5, padding: '3px 6px',
                      fontSize: '0.7rem', fontWeight: 700, color: '#fff',
                      display: 'flex', alignItems: 'center', gap: 3,
                    }}>
                      <Hash size={10} /> {pedido}
                    </div>
                    <span style={{ fontSize: '0.78rem', color: T.textSub, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <MapPin size={11} />{grouped[pedido].APELIDO}
                    </span>
                  </div>
                  {grouped[pedido].FRETE !== 0 && (
                    <Chip color={T.accentAlt}>
                      <Truck size={10} /> {fmtCur(grouped[pedido].FRETE)}
                    </Chip>
                  )}
                </div>

                {/* Items */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  {grouped[pedido].DESCRICAO.map((desc, idx) => (
                    <div key={idx} style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      padding: '7px 10px', background: T.surface,
                      borderRadius: 7, border: `1px solid ${T.border}`,
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
                        <Package size={11} color={T.muted} />
                        <span style={{ fontSize: '0.8rem', color: T.text, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {desc}
                        </span>
                        <span style={{
                          background: T.surfaceHi, padding: '1px 7px',
                          borderRadius: 5, fontSize: '0.68rem',
                          color: T.textSub, fontWeight: 600,
                          border: `1px solid ${T.border}`,
                        }}>{grouped[pedido].QUANTIDADE[idx]}</span>
                        {grouped[pedido].INTEGRADO[idx] === 'fulfillment' && (
                          <Chip color={T.success}><Zap size={9} /> Full</Chip>
                        )}
                      </div>
                      <div style={{
                        marginLeft: 10, padding: '3px 8px', borderRadius: 6,
                        background: `${T.success}15`, border: `1px solid ${T.success}25`,
                        fontSize: '0.78rem', fontWeight: 700, color: T.success, flexShrink: 0,
                      }}>
                        {fmtCur(grouped[pedido].VALOR_TOTAL_ITEM[idx])}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: 12, fontSize: '0.75rem', color: T.textSub }}>
          {Object.keys(grouped).length} pedido(s) encontrado(s)
        </div>
      </div>
    )
  }

  /* ── Modal Itens Vendidos ── */
  const ModalItensVendidos = () => (
    <Modal show={showModal} onHide={handleClose} centered dialogClassName="custom-modalzpl">
      <Modal.Header closeButton>
        <Modal.Title style={{ color: T.text }}>Itens Vendidos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {dadosDashboard?.totalItensParts?.length > 0 ? (
          <Table responsive className="text-center align-middle">
            <thead>
              <tr>
                {['Loja', 'SKU', 'Descrição', 'Qtd', 'Valor Total'].map(h => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dadosDashboard.totalItensParts.map((item, i) => (
                <tr key={i}>
                  <td>{item.apelido_loja}</td>
                  <td><code style={{ fontFamily: T.fontMono, color: T.accentAlt }}>{item.sku}</code></td>
                  <td>{item.descricao || 'Sem descrição'}</td>
                  <td><Chip color={T.accent}>{item.quantidade_total}</Chip></td>
                  <td style={{ color: T.success, fontWeight: 700 }}>
                    {item.valor_total_vendido?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <EmptyState message="Nenhum item vendido." />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="dark" className="w-100" onClick={handleClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  )

  /* ────────────────── RENDER ────────────────── */
  const isAdmin = localStorage.admin !== 'NAO'

  return (
    <>
      <GlobalStyles />
      <Navbar />

      <div className="mt-page dashboard-root" style={{ padding: '20px 24px', width: '100%', background: '#f4f6f9', minHeight: '100vh' }}>
        <GreetingBanner />
        <CatalogNotification />

        {isAdmin ? (
          <>
            <DashboardVendas
              dadosDashboard={dadosDashboard}
              isLoading={isLoading}
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
            />

            <DashboardMonthly />
            <AnunciosDashboard data={anuncios} />
            <AccountStatistics />

            {dadosVendas.length > 0 && <SalesRanking />}

            <TabelaVendas totalDiario={totalDiario} />

            {dadosVendasFull.length > 0 && <FulfillmentDashboard />}

            <ItemList />

            {/* Comparativos */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>
              <ComparativoVendasCard informacoesVendas={dadosVendasComparativo} />
              <ComparativoValorTotalCard informacoesVendas={dadosVendasComparativo} />
            </div>

            <OrderList />

            <div style={{ marginBottom: 24 }}>
              <ScheduleCard sellerData={dadosMetricas.results} />
            </div>

            <CodigosAutorizacao />

            {/* Gráfico anual */}
            <div style={{
              background: T.surface, border: `1px solid ${T.border}`,
              borderRadius: T.radius, padding: 24, marginBottom: 24,
            }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
                <SectionHeader title="Vendas por Ano" icon={BarChart3} />
                <Dropdown>
                  <Dropdown.Toggle variant="secondary" id="dropdownAno" style={{ fontSize: '0.85rem' }}>
                    {anoSelecionado}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {anosDisponiveis.map(ano => (
                      <Dropdown.Item key={ano} onClick={() => handleDropdownChange(ano)}>{ano}</Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {isLoadingAno ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {[1, 2, 3].map(i => <LoadingRow key={i} />)}
                </div>
              ) : dados.length > 0 ? (
                <div style={{ width: '100%' }}>
                  <TabelaComparativa dados={dados} />
                </div>
              ) : (
                <EmptyState message="Nenhum dado disponível para este ano." />
              )}
            </div>
          </>
        ) : (
          <>
            <OrderList />
            <DashboardMonthly />
            <AnunciosDashboard data={anuncios} />
            <ItemList />
            <div style={{ marginBottom: 24 }}>
              <ScheduleCard sellerData={dadosMetricas.results} />
            </div>
            <CodigosAutorizacao />
          </>
        )}
      </div>

      <ModalItensVendidos />

      {/* Daily Sales Modal */}
      {isModalDailySalesOpen && (
        <Modal show centered size="lg" dialogClassName="custom-modalzpl">
          <Modal.Header>
            <Modal.Title style={{ color: T.text }}>Vendas de Hoje</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isDailySalesLoading ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, padding: '24px 0' }}>
                <Loader2 size={28} color={T.accent} className="spin-anim" />
                <span style={{ color: T.textSub }}>Carregando...</span>
              </div>
            ) : (
              <Table>
                <thead>
                  <tr>
                    {['Pedido', 'Cliente', 'Valor', 'Ação'].map(h => <th key={h}>{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {dailySales.map(sale => (
                    <tr key={sale.pedido}>
                      <td style={{ fontFamily: T.fontMono }}>{sale.pedido}</td>
                      <td>{sale.cliente}</td>
                      <td style={{ color: T.success, fontWeight: 700 }}>{formatPrice(sale.valor)}</td>
                      <td>
                        <OverlayTrigger overlay={<BootstrapTooltip>Visualizar Pedido</BootstrapTooltip>}>
                          <CustomButton onClick={() => navigate(`/pedido/editar/${sale.pedido}`)}>
                            <BoxArrowUpRight size={14} />
                          </CustomButton>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Modal.Body>
          <Modal.Footer>
            <CustomButton title="Fechar" onClick={() => setIsModalDailySalesOpen(false)} color={T.muted} />
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export default Main